module.exports = __webpack_public_path__ + "img/down.4b84184b.svg";